import { generateViewConversationUrl } from '@wix/ambassador-asa-conversation-v1-conversation/http';
import { WithLogger } from '../../logger/WithLogger';
export class ConversationsClient extends WithLogger {
  constructor(httpClient, logger) {
    super(logger);
    this.httpClient = httpClient;
  }
  async generateViewConversationUrl(conversationId) {
    try {
      const {
        data: {
          url
        }
      } = await this.httpClient.request(generateViewConversationUrl({
        conversationId
      }));
      if (!url) {
        throw new Error('url is undefined');
      }
      return url;
    } catch (error) {
      this.logInfo('generateViewConversationUrl', 'Failed to generate url', {
        conversationId
      });
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'ConversationsClient';
  }
}
//# sourceMappingURL=ConversationsClientHttp.js.map